import { robotoRegular, scarpaGray500 } from '@habitech/shared';
import { styled } from 'styled-components';

export const WrapperFieldsToCorrect = styled.div`
  .form-label {
    font-size: 12px;
    font-family: ${robotoRegular};
  }
  .form-control {
    font-size: 14px;
    font-family: ${robotoRegular};

    &::placeholder {
      color: ${scarpaGray500};
      opacity: 1;
    }

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    &[type='number'] {
      -moz-appearance: textfield;
      appearance: textfield;
    }
  }

  .invalid-feedback {
    font-size: 12px;
    font-family: ${robotoRegular};
  }
`;
